import { useState } from "react";

export default function usePcodeConfirmed() {
    const getConfirmed = () => {
        const confirmedString = localStorage.getItem('pcodeConfirmed');
        const confirmed = JSON.parse(confirmedString);
        return confirmed?.confirmed === true;
    };

    const [pcodeConfirmed, setConfirmedState] = useState(getConfirmed());

    const saveConfirmed = confirmed => {
        localStorage.setItem('pcodeConfirmed', `{"confirmed":${confirmed}}`);
        setConfirmedState(confirmed);
    };

    return {
        setPcodeConfirmed: saveConfirmed,
        pcodeConfirmed
    }
}
